//import '@babel/polyfill'
//import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

//import { BootstrapVue} from 'bootstrap-vue'
//Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { CarouselPlugin } from 'bootstrap-vue'
Vue.use(CarouselPlugin)


Vue.config.productionTip = false
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
 
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
